import React from 'react'

type Props = {
  //
}

const AppLogo: React.FC<Props> = () => (
  <div className="sidebar-header text-center app-logo">
    <img src="/assets/img/GMTS_logo.png" alt="GMTS 店舗会員登録申請" width="145" />
  </div>
)

export default AppLogo
